import { Messages } from '../../../../codegen/Localize';
import { ISetProjectAction } from '../../../../ts/ServerApi/types/actionNames';
import { moveContents } from '../../../actions/MoveContentsAction';
import { IContentInfo } from '../../../models/IContentInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { anyItemIsEmbeddedDatasource } from './IEntityActionHelpers';

export const MoveAction: IEntityAction<IContentInfo, ISetProjectAction> = {
  name: EntityActionNames.Move,
  translateName: Messages.move_action,
  isVisible: (targetItems: IContentInfo[]) => {
    return !anyItemIsEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: ISetProjectAction) => !!(availableActions && availableActions.setProject),
  createReduxAction: (targetItems: IContentInfo[]) => moveContents(targetItems)
};
